import { Deserializable } from './deserializable';

export class ListResponse implements Deserializable{
  status: number;
  msg: string;
  data: {
    page: number;
    pageSize: number;
    total: number;
    list: [];
  };

  deserialize(input: any, model: any): this {
    Object.assign(this, input);

    this.data.list = input.data.list.map(data => new model().deserialize(data));

    return this;
  }
}
